"use client"

import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "@/components/ui/dialog"
import { LoginForm } from "@/components/login-form"
import { useUser } from "@/components/user-context"
import { type User } from "@/lib/auth"
import { type LoginResponse } from "@/lib/api-v3"
import { toast } from "sonner"
import { debugLog } from "@/lib/debug"

interface AccountLoginDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function AccountLoginDialog({ open, onOpenChange }: AccountLoginDialogProps) {
  const { addAccount } = useUser()

  const handleLoginSuccess = async (user: User, tokens: LoginResponse) => {
    try {
      debugLog('auth', "✅ Успешный вход в диалоге, добавляем аккаунт...")
      
      // Преобразуем LoginResponse в AuthTokens
      const authTokens = {
        accessToken: tokens.accessToken,
        refreshToken: tokens.refreshToken,
        expiresAt: Date.now() + tokens.expiresIn * 1000,
      }
      
      // Закрываем диалог
      onOpenChange(false)
      
      // Показываем уведомление
      toast.success("Аккаунт добавлен!", {
        description: `Переключение на ${user.name}...`,
        duration: 2000,
      })
      
      // Добавляем аккаунт (автоматически переключится и перезагрузит страницу)
      await addAccount(user, authTokens)
      
    } catch (error) {
      console.error("Ошибка при добавлении аккаунта:", error)
      toast.error("Ошибка при добавлении аккаунта")
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogTitle className="sr-only">Войти в новый аккаунт</DialogTitle>
        <LoginForm 
          isDialog={true}
          onSuccess={handleLoginSuccess}
        />
      </DialogContent>
    </Dialog>
  )
}
